import styled from 'styled-components';
import ImageMap from 'image-map';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  background-color: #121212;

  img {
    width: 100%;
    min-width: 800px;
  }
`;

const Area = styled.area`
  cursor: pointer;
  border: none;
  outline: none;
`;

const Home = () => {
  const navigate = useNavigate();

  const onLoad = () => {
    ImageMap('img[usemap]');
  };

  return (
    <Container>
      <map name="image-map">
        <Area
          alt="mar"
          title="mar"
          coords="142,290,203,309,235,359,226,420,182,478,184,571,96,573,99,480,53,420,43,359,75,305"
          shape="poly"
          onClick={() => navigate('/owlmar_oukaimeden')}
          href=""
        />
        <Area
          alt="isr"
          title="isr"
          coords="372,297,428,320,457,366,460,427,433,461,406,490,410,587,327,588,328,493,303,463,272,426,274,366,311,312"
          shape="poly"
          onClick={() => navigate('/owlisr_mitzperamon')}
          href=""
        />
        <Area
          alt="mng"
          title="mng"
          coords="737,202,788,225,818,261,829,309,812,353,773,392,774,488,689,492,689,393,656,351,635,309,645,254,679,215"
          shape="poly"
          onClick={() => navigate('/owlmng_songino')}
          href=""
        />
        <Area
          target=""
          alt="kor"
          title="kor"
          coords="879,473,934,510,961,548,976,598,964,641,925,680,927,761,844,766,839,682,798,641,786,598,793,549,829,507"
          shape="poly"
          onClick={() => navigate('/owlkor_bohyun')}
          href=""
        />
        <Area
          target=""
          alt="usa"
          title="usa"
          coords="1541,288,1495,293,1460,326,1443,368,1449,420,1475,451,1502,476,1505,573,1587,575,1580,473,1610,448,1633,409,1633,356,1614,324,1585,298"
          shape="poly"
          onClick={() => navigate('/owlusa_lemmon')}
          href=""
        />
      </map>
      <img src="/assets/main.png" useMap="#image-map" alt="map" onLoad={onLoad} />
    </Container>
  );
};

export default Home;
